"use client";

import Card from "../Card";
import { Swiper, SwiperSlide } from "swiper/react";

type ButtonType = {
  text: string;
  link: string;
};

type CardType = {
  bg: {
    src: {
      desktop: string;
      tablet: string;
      mobile: string;
    };
    alt: string;
  };
  overImageTitle?: string;
  title: string;
  body: string;
  button: ButtonType;
};

type DoubleCardsProps = {
  component: {
    type: string;
    content: {
      cards: CardType[];
    };
  };
};

const DoubleCards = ({ component }: DoubleCardsProps) => {
  return (
    <Swiper
      enabled={true}
      slidesPerView={1.2}
      spaceBetween={25}
      className="cards"
      observer
      breakpoints={{
        1200: {
          enabled: false,
          slidesPerView: 2,
          spaceBetween: 50,
        },
      }}
    >
      {component.content.cards.map((card) => (
        <SwiperSlide className="cards__item" key={card.title}>
          <Card card={card} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default DoubleCards;
